/**
 * Route path patterns (React Router `:param` syntax) for pages where a
 * version-mismatch page reload is safe — i.e. the user is not mid-flow and
 * a reload will not lose unsaved work.
 *
 * This is a manually maintained list that must be kept in sync with
 * _RELOAD_SAFE_ROUTE_KEYS in routePaths.ts. This file exists as a standalone
 * module to avoid a circular dependency:
 *   routes.ts → (page components) → apiCalls.tsx → api.ts → versionCheck.ts
 *
 * routePaths.ts uses a `satisfies` constraint on _RELOAD_SAFE_ROUTE_KEYS to ensure
 * every listed route key exists in rawRoutesBase. If a key is renamed or removed
 * from rawRoutesBase, TypeScript will error in routes.ts, prompting the developer
 * to update both _RELOAD_SAFE_ROUTE_KEYS and this file.
 */
export const RELOAD_SAFE_ROUTE_PATHS = [
  "/",
  "/dashboard",
  "/nhs-dashboard",
  "/data-glossary",
  "/patient-list",
  "/caseload/user-caseload",
  "/caseload/caseload",
  "/caseload/archive",
  "/notifications",
  "/patients",
  "/patients/:patientId",
  "/patients/:patientId/activity-log",
  "/patients/:patientId/edit",
  "/patients/:patientId/forms/:formContextId",
  "/patients/:patientId/forms/:formContextId/activity-log",
  "/profile/:userId",
  "/manager/users",
  "/manager/teams",
  "/mha-status-dashboard",
] as const;
